export default {
  namespaced: true,
  state: {
    notificationsList: [],
    notification: null,
    lastShowTime: [],
    hasNotifications: false,
  },
  actions: {
    async GetNotifications({ commit, state, rootGetters }, profileId) {
      const response = await rootGetters.ax.post('notifications/api/notifications/list', {
        profile_id: profileId,
      });
      if (!response || !response.data || !Array.isArray(response.data.notifications)) {
        throw new Error('Notifications are missing from the response');
      }
      const timestamp = Math.floor(Date.now() / 1000);
      const notifications = response.data.notifications.filter((item) => {
        const previous = state.lastShowTime.find(shown => shown.id === item.id);
        return !previous || timestamp - previous.time > item.frequency_hours * 3600;
      });
      // Keep dismissal times when the filtered list is empty.
      commit('SetNotificationsList', notifications);
      commit('SetNotification', notifications[0] || {});
      commit('SetNotificationsFlag', notifications.length > 0);
      return notifications;
    },
    successNotification({ commit, rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('notifications/api/notifications/answer', { profile_id: payload.profile_id, notification_id: payload.notification_id })
          .then((response) => {
            if (response && response.data) {
              response.data.answer.id && commit('InitialStoreNotifications');
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreNotifications({ commit }) {
      commit('InitialStoreNotifications');
    },
  },
  mutations: {
    SetNotificationsList(state, notifications) {
      state.notificationsList = notifications;
    },
    SetNotificationsFlag(state, payload) {
      state.hasNotifications = payload;
    },
    SetNotification(state, payload) {
      state.notification = payload;
    },
    SetLastShowTime(state, payload) {
      if (state.lastShowTime.length && payload.time === null) {
        const findIndexNotification = state.lastShowTime.findIndex(x => x.id === payload.id);
        (findIndexNotification !== -1) && state.lastShowTime.splice(findIndexNotification, 1);
      } else if (state.lastShowTime.length && payload.time !== null) {
        const findIndexNotification = state.lastShowTime.findIndex(x => x.id === payload.id);
        if (findIndexNotification !== -1) {
          state.lastShowTime[findIndexNotification].time = payload.time;
        } else {
          state.lastShowTime.push({ id: payload.id, time: payload.time });
        }
      } else {
        state.lastShowTime.push({ id: payload.id, time: payload.time });
      }
    },
    InitialStoreNotifications(state) {
      state.notificationsList = [];
      state.notification = {};
      state.lastShowTime = [];
      state.hasNotifications = false;
    },
  },
};
